import { RadialCounter } from '@theme/radial-counter';

/**
 * Dose meter — the radial counter used by the `dosage-meter` section.
 *
 * The `<dose-meter>` host shares the exact contract of `<radial-counter>`
 * (refs `value`/`arc`, `data-target`/`data-max`/`data-duration`), so it reuses
 * the same {@link RadialCounter} behavior instead of duplicating the animation:
 * a single `requestAnimationFrame` tick drives BOTH the number count-up and the
 * SVG arc fill from the same eased progress, keeping them perfectly in sync.
 *
 * A custom-element constructor can only be registered under ONE tag name, and
 * `RadialCounter` is already bound to `<radial-counter>`. So we register an
 * (empty) subclass — a distinct constructor with identical behavior — under
 * `<dose-meter>`. Defining `RadialCounter` directly would throw NotSupportedError.
 *
 * The section server-renders the FINAL state, so no-JS and reduced-motion users
 * see the correct value with no animation.
 */
class DoseMeter extends RadialCounter {}

if (!customElements.get('dose-meter')) {
  customElements.define('dose-meter', DoseMeter);
}
